import React from 'react';
import { Redirect, Route as ReactDOMRoute, Switch } from 'react-router-dom';
import { Permissoes } from '../services/hooks/usePermissoes';

import Route from './Route';

import SignIn from '../pages/SignIn';
import SsoCallback from '../pages/SsoCallback';
import SsoLogout from '../pages/SsoLogout';
import Forgot from '../pages/Forgot';
import CreateAccount from '../pages/CreateAccount';
import Dashboard from '../pages/Dashboard';
import Canais from '../pages/Canais';
import Produtos from '../pages/Produtos';
import Pedidos from '../pages/Pedidos';
import Fila from '../pages/Fila';
import Usuarios from '../pages/Usuarios';
import Logs from '../pages/Logs';
import Regras from '../pages/Regras';
import Configuracoes from '../pages/Configuracoes';
import LiveCommerce from '../pages/LiveCommerce';
import Automacao from '../pages/Automacao';
import Ajuda from '../pages/Ajuda';
import NovoProduto from '../pages/NovoProduto';
import RevisarImportacao from '../pages/EditarExcel/RevisarImportacao';
import EditarProduto from '../pages/EditarProduto';
import SincronizacaoLote from '../pages/StatusDoEnvio';
import AdminEmpresa from '../pages/AdminEmpresa';
import DetalhesPedido from '../pages/Pedidos/DetalhesPedido';
import UsuarioDetalhes from '../pages/AdminEmpresa/UsuarioDetalhes';
import TokenIntegra from '../pages/TokenIntegra';
import GerarTokenIntegra from '../pages/TokenIntegra/GerarToken';

const Routes: React.FC = () => (
  <Switch>
    <ReactDOMRoute exact path="/" render={() => <Redirect to="/login" />} />
    <ReactDOMRoute exact path="/sso/callback" component={SsoCallback} />
    <ReactDOMRoute exact path="/sso/logout" component={SsoLogout} />
    <Route exact path="/login" component={SignIn} />
    <Route exact path="/forgot" component={Forgot} />
    <Route exact path="/create-account" component={CreateAccount} />
    {/* <Route exact path="/dashboardCEO" component={DashboardCEO} isPrivate /> */}
    <Route
      exact
      path="/dashboard"
      component={Dashboard}
      isPrivate
      permissao={Permissoes.DASHBOARD_VIEW}
    />
    {/* <Route exact path="/dashboard/analytics" component={Analytics} isPrivate /> */}
    <Route exact path="/dashboard/canais" component={Canais} isPrivate />
    <Route exact path="/dashboard/produtos" component={Produtos} isPrivate />
    <Route
      exact
      path="/pedidos"
      component={Pedidos}
      isPrivate
      permissao={Permissoes.PEDIDOS_VIEW}
    />
    <Route exact path="/fila" component={Fila} isPrivate />
    <Route exact path="/usuarios" component={Usuarios} isPrivate />
    <Route
      exact
      path="/canais"
      component={Canais}
      isPrivate
      permissao={Permissoes.API_TOKENS_MANAGE}
    />
    <Route
      exact
      path="/produtos"
      component={Produtos}
      isPrivate
      permissao={Permissoes.PRODUTOS_VIEW}
    />
    <Route
      exact
      path="/produtos/novo"
      component={NovoProduto}
      isPrivate
      permissao={Permissoes.PRODUTOS_CREATE}
    />
    <Route exact path="/logs" component={Logs} isPrivate />
    <Route exact path="/regras" component={Regras} isPrivate />
    <Route exact path="/configuracoes" component={Configuracoes} isPrivate />
    <Route exact path="/LiveCommerce" component={LiveCommerce} isPrivate />
    <Route exact path="/automacao" component={Automacao} isPrivate />
    <Route exact path="/ajuda" component={Ajuda} isPrivate />
    <Route
      exact
      path="/novo-produto"
      component={NovoProduto}
      isPrivate
      permissao={Permissoes.PRODUTOS_CREATE}
    />
    <Route
      exact
      path="/admin-empresa"
      component={AdminEmpresa}
      isPrivate
      permissao={Permissoes.EMPRESA_ADMIN}
    />

    <Route
      exact
      path="/produtos/sincronizacao-em-lote/:batchId"
      component={SincronizacaoLote}
      isPrivate
    />
    <Route
      exact
      path="/produtos/editar/:id"
      component={EditarProduto}
      isPrivate
      permissao={Permissoes.PRODUTOS_UPDATE}
    />
    <Route
      exact
      path="/produtos/revisar-importacao"
      component={RevisarImportacao}
      isPrivate
      permissao={Permissoes.PRODUTOS_CREATE}
    />
    <Route
      exact
      path="/admin-empresa/usuarios/:id"
      component={UsuarioDetalhes}
      isPrivate
      permissao={Permissoes.EMPRESA_ADMIN}
    />
    <Route path="/pedidos/:id" component={DetalhesPedido} isPrivate />

    <Route
      exact
      path="/tokens/integra"
      component={TokenIntegra}
      isPrivate
      permissao={Permissoes.API_TOKENS_MANAGE}
    />
    <Route
      exact
      path="/tokens/integra/novo"
      component={GerarTokenIntegra}
      isPrivate
      permissao={Permissoes.API_TOKENS_MANAGE}
    />
    {/* <Route
      exact
      path="/dashboard/debts-to-receive"
      component={DebtsToReceive}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/debts-to-pay"
      component={DebtsToPay}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/comparative"
      component={Comparative}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/movement/:id"
      component={Movement}
      isPrivate
    />
    <Route exact path="/financial" component={Financial} isPrivate />
    <Route exact path="/financial/caixas" component={Caixa} isPrivate />
    <Route
      exact
      path="/financial/cost-control"
      component={CostControl}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/cost-control/department-cost-control/:id"
      component={DepartmentCostControl}
      isPrivate
    />
    <Route exact path="/financial/dre" component={DRE} isPrivate />
    <Route
      exact
      path="/financial/total-received"
      component={TotalReceived}
      isPrivate
    />
    <Route exact path="/financial/total-paid" component={TotalPaid} isPrivate />
    <Route
      exact
      path="/financial/debts/:type/:status"
      component={Debts}
      isPrivate
    />
    <Route exact path="/dashboard/sales" component={Sales} isPrivate />
    <Route
      exact
      path="/dashboard/sales/seller-sales/:id"
      component={SellerSales}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/sales/department-sales/:id"
      component={DepartmentSales}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/sales/best-selling-products"
      component={BestSellingProducts}
      isPrivate
    />
    <Route exact path="/dashboard/purchases" component={Purchases} isPrivate />
    <Route
      exact
      path="/dashboard/purchases/supplier-purchases/:id"
      component={SupplierPurchases}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/purchases/department-purchases/:id"
      component={DepartmentPurchases}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/purchases/most-purchased-products"
      component={MostPurchasedProducts}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/system-reports"
      component={SystemReports}
      isPrivate
    />
    <Route exact path="/dashboard/my-reports" component={MyReports} isPrivate />
    <Route
      exact
      path="/dashboard/my-reports/generate/:report_id"
      component={GenerateReport}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/my-reports/view/:report_id"
      component={ViewReport}
      isPrivate
    />
    <Route
      exact
      path="/dashboard/my-reports/create"
      component={CreateReport}
      isPrivate
    />
    <Route exact path="/dashboard/favorites" component={Favorites} isPrivate />
    <Route exact path="*" component={Notfound} isPrivate /> */}
  </Switch>
);

export default Routes;
